import { SOCIAL_PROOF } from "@/lib/constants";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { Quote } from "lucide-react";

export default function SocialProof() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      data-testid="social-proof-section"
      className="bg-white py-16 md:py-24"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Stats bar */}
        <div
          data-testid="stats-bar"
          className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16 mb-16"
        >
          {/* Placeholder numbers - update with real data */}
          {SOCIAL_PROOF.stats.map((stat, i) => (
            <div
              key={stat.label}
              data-testid={`stat-${i}`}
              className="text-center"
            >
              <div className="font-heading text-5xl sm:text-6xl md:text-7xl font-extrabold text-[#20611B] leading-none">
                {stat.value}
              </div>
              <div className="text-sm text-[#6B7280] mt-2 font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Testimonial cards */}
        <div
          ref={ref}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8"
        >
          {SOCIAL_PROOF.testimonials.map((testimonial, i) => (
            <div
              key={i}
              data-testid={`testimonial-card-${i}`}
              className={`bg-[#F9FAFB] border border-gray-200 rounded-xl p-6 md:p-8 transition-all duration-500 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <Quote className="h-6 w-6 text-[#D4A84B] mb-4" />
              <blockquote className="text-[#1A1A1A] text-sm leading-relaxed mb-6">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex items-center gap-3">
                {/* Placeholder photo */}
                <div className="w-10 h-10 rounded-full bg-gray-200 border-2 border-gray-300 flex items-center justify-center text-xs text-[#6B7280]">
                  Photo
                </div>
                <div>
                  <div className="text-sm font-semibold text-[#1A1A1A]">
                    {testimonial.name}
                  </div>
                  <div className="text-xs text-[#6B7280]">
                    {testimonial.trade}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
